import type { Message } from '../../api/chat';

const UNANSWERED_CALL_OUTCOMES = new Set(['missed', 'no_answer', 'failed', 'declined']);

type CallEventLike = Pick<Message, 'message_type' | 'body' | 'content'>;

function callEventBody(message: CallEventLike): Record<string, unknown> {
  return message.body && typeof message.body === 'object' ? message.body : {};
}

export function isCallEventMessage(message: Partial<CallEventLike> | null | undefined): boolean {
  return message?.message_type === 'call_event';
}

export function callEventInitiatorId(message: CallEventLike): string | null {
  const initiator = callEventBody(message).initiator_user_id;
  return typeof initiator === 'string' && initiator.trim() ? initiator : null;
}

export function isOwnCallEvent(message: CallEventLike, currentUserId: string): boolean {
  return isCallEventMessage(message) && !!currentUserId && callEventInitiatorId(message) === currentUserId;
}

export function formatCallEventPreview(message: CallEventLike, currentUserId: string): string | null {
  if (!isCallEventMessage(message)) return null;

  const body = callEventBody(message);
  const outcome = typeof body.outcome === 'string' ? body.outcome : '';
  const isGroup = body.is_group === true;
  const isVideo = body.call_type === 'video';
  const unanswered = UNANSWERED_CALL_OUTCOMES.has(outcome);
  const iAmInitiator = !!currentUserId && callEventInitiatorId(message) === currentUserId;

  if (isGroup) {
    if (unanswered) return 'Missed group call';
    return isVideo ? 'Group video call' : 'Group call';
  }

  if (unanswered) {
    if (iAmInitiator) return outcome === 'declined' ? 'Call declined' : 'No answer';
    return isVideo ? 'Missed video call' : 'Missed voice call';
  }

  return isVideo ? 'Video call' : 'Voice call';
}
